module.exports = __webpack_public_path__ + "static/media/bg.0b819d63.svg";